module.exports = __webpack_public_path__ + "img/4-1.72cb6ec6.png";